export default {
	templates: {
		devMode: "Dev Mode",
		templates: "Templates",
		create: "Create",
		name_of_template: "Name of Template",
		template_type: "Template type",
		template_name: "Template Name",
		password_liquid: "Password Liquid",
		graphQl_query: "GraphQL Query",
		graphQl_variables: "GraphQl Variables",
		spacing: "Spacing",
		margin: "Margin",
		marginTop: "Margin Top",
		marginRight: "Margin Right",
		marginLeft: "Margin Left",
		marginBottom: "Margin Bottom",
		update: "Update",
		select_pdf: "Select PDF File",
		field_required: "This field is required",
		plainTextRequired: "Plain text content cannot be empty",
		name: "Name",
		description: "Description",
		type: "Type",
		created: "Created",
		lastModified: "Last Modified",
		filter: "Filter Templates",
		pdfDrawing: "Pdf Drawing",
		emailMjml: "Email",
		emailMode: "Email Mode",
		emailModeMjml: "MJML",
		emailModePlaintext: "Plain Text",
		htmlToPdf: "Html to Pdf",
		clauseHtml: "Clause Html",
		dynamic: "Dynamic",
		function: "Function",
		notification: "Notification",
		header: "Header",
		body: "Body",
		footer: "Footer",
		document_settings: "Document Settings",
		editor: "Document Editor",
		cancel: "Cancel",
		save: "Save",
		attachment_settings: "Attachment Settings",
		send_test_email: "Send Test",
		delete_template: "Delete Template",
		download_preview: "Download Preview",
		confirm: "Confirm",
		delete_dialog: "Are you sure you want to delete this template? This process cannot be reverted.",
		discard_changes: "Discard changes?",
		discard_dialog: "Are you sure you want to discard all changes? This process cannot be reverted.",
		documentSettings: "Document Settings",
		sendTestEmail: "Send Test Email",
		graphQlQuery: "GraphQl Query",
		selectPredefinedQueries: "Select Predefined Queries",
		customizeQuery: "Customize Query",
		addTemplateAsAttachment: "Add Template as Attachment",
		selectTemplate: "Select Template",
		add: "Add",
		addFile: "Add File as Attachment",
		cancelChangesText: "Are you sure you want to cancel? All unsaved progress will be lost.",
		yes: "Yes",
		no: "No",
		attachments: "Attachments",
		deleteTemplate: "Delete Template",
		send: "Send",
		emailAddress: "Email Address",
		changePromptText: "Changes have been made, do not forget to save progress.",
		templateSaved: "Template Saved",
		templateDeleted: "Template Deleted",
		delete: "Delete",
		deleteText: "Are you sure you want to delete this template? This action cannot be reverted.",
		confirmDelete: "Type 'DELETE' to confirm",
		addedAttachment: "Attachment Added",
		removedAttachment: "Attachment Removed",
		saveGraphQlQuery: "Save GraphQl Query",
		emailSent: "Test Email Sent!",
		subject: "Subject",
		download: "Download",
		browser_not_supported: "Browser not supported",
		graphQlVariables: "GraphQl Variables",
		previewMockData: "Preview data",
		previewData: "Preview data",
		previous: "Prev",
		next: "Next",
		page_number: "Page Number",
		textAlignment: "Text Alignment",
		font: "Font",
		liquid: "Liquid",
		x: "X",
		y: "Y",
		w: "W",
		h: "H",
		previewSettings: "Preview Settings",
		pdfFile: "PDF File",
		selectOrUploadFile: "Select or Upload File",
		loadingFileMessage: "Please be patient while we load your file.",
		saved: "Saved",
		defineSpacing:
			"Input below the amount of space to put between the header and the content, e.g. '1.8'. Be aware that if this is too large the header will be printed outside the pdf document. This can be corrected with the margin top setting.",
		advancedSettings: "Advanced Settings",
		undoChanges: "Undo Changes",
		downloadText: "Please update changes before downloading, as uncommitted changes will not be reflected",
		fileDownloaded: "File downloaded successfully",
		changesHaveBeenDiscarded: "Changes have been discarded",
		fileDoesNotExist: "File does not exist. Please try to add attachment again.",
		templateDoesNotExist: "Template does not exist. Please try to add attachment again.",
		preview: "Preview",
		back: "Back",
		close: "Close",
		contentJsonString: "Populate Variables",
		variablesPopulate: "Render variables by typing {{ data.variable_name }}. Variables can be populated in Preview Settings",
		content: "Content",
		language: "Language",
		changesUnsaved: "Changes unsaved will not be reflected",
		liquidPicker: "Liquid Picker",
		smsNotification: "SMS Notification",
		renderTemplate: "Render Template",
		sms: "SMS",
		dynamicValues: "Dynamic Values",
		total: "Total",
		value: "Value",
		hasBeenRemoved: "The following dynamic value has been successfully removed: ",
		dynamicValueAdded: "Dynamic value has been added",
		noDynamicValueSelected: "No dynamic value has been selected",
		noDataIsAvailable: "No data is available, click 'add' to initialize a new data array",
		continueEditing: "Continue Editing",
		discardChanges: "Discard Changes",
		templateAutosaved: "Template has been autosaved",
		renderedSms: "Rendered SMS",
		done: "Done",
		renderedNotification: "Rendered Notification",
		noTemplate: "There is no template with this id.",
		problemWithGql: "There is a problem with your GraphQl query",
		problemWithVariables: "There is a problem with your variables populating",
		excelFile: "Excel File",
		inputNotAdded: "Input exists on excel but not added to template",
		inputNotExist: "Input does NOT exist on Excel but is added to template",
		outputNotAdded: "Output exists on excel but not added to template",
		outputNotExist: "Output does NOT exist on Excel but is added to template",
		pleaseSelectExcelFile: "File not compatible, please select an excel file.",
		noFunctionTemplateData: "No data is available, select an excel file to initialize data.",
		inputFields: "Input Fields",
		outputFields: "Output Fields",
		noPreview: "No preview available",
		refresh: "Refresh",
		renderPreview: "Render Preview",
		downloadPreview: "Download Preview",
		logicalId: "Logical ID"
	}
}
